import React, { Component, useState, useEffect } from 'react'
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { auth, storage, firestore, analytics } from "../../firebase";
import { Typography, Box, Button } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import FacebookLogin from 'react-facebook-login';
import LoginPage from '../LoginPage';
import moment from "moment";

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        margin: theme.spacing(2),
        paddingTop: 32
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
});

function OAuth(props) {
    const [tokenActive, setTokenActive] = useState(false);
    const [expiresIn, setExpiresIn] = useState('');
    const [fbLoggedIn, setFbLoggedIn] = useState(false);
    const [userLoggedIn, setUserLoggedIn] = useState(false);

    useEffect(() => {
        if (props.user) {
            firestore.collection('users').doc(props.user.uid).get().then((snapshot) => {
                const user = snapshot.data();
                if (user.facebook) {
                    const time = moment.unix(user.facebook.data_access_expiration_time).format('YYYY-MM-DDTHH:mm');
                    setTokenActive(true)
                    setExpiresIn(time + '')
                } else {
                    setTokenActive(false)
                }
            }, err => {
                props.openSnackbar("Error Loading user. Please login first.", 'error');
            })
            setUserLoggedIn(true)
        } else {
            setUserLoggedIn(false)
        }
    })




    const responseFacebook = (o) => {
        if (props.user) {
            firestore.collection('users').doc(props.user.uid).update({
                facebook: o
            }).then((success) => {
                //TODO: this will close the window and let the app know that the 
            }, err => {
                props.openSnackbar("Error storing Token.", 'error');
            })
        } else {
            props.openSnackbar("Please Login first", 'warning');
        }
    }

    return (
        <div >
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" 
            color="inherit" 
            aria-label="menu"
            onClick={()=> window.location = 'close'}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h6"   >
            Link Accounts
          </Typography>
        </Toolbar>
      </AppBar>
      <Box style={{ marginTop: 40 }}>
            {userLoggedIn ?
                <React.Fragment>
                    <Typography variant="h6">
                        Link FB Account. ExpiresIn [{expiresIn}]
                        </Typography>
                    <FacebookLogin
                        appId="499506194079954"
                        autoLoad={false}
                        fields="name,email,picture"
                        scope="public_profile,pages_read_engagement,pages_show_list,pages_manage_posts"
                        callback={responseFacebook}
                    />
                </React.Fragment>
                :
                <LoginPage openSnackbar={props.openSnackbar} />
            }
        </Box>
    </div>
    )
}

export default withRouter(OAuth)